import React, { useState } from 'react'
import PasswordInputField from "./PasswordInputField";
import ConfirmPasswordInputField from "./ConfirmPasswordInputField";
import { useNavigate,useParams } from 'react-router-dom';
import {register} from './config/Variables';
import Header from './partials/Header';

function PasswordAndConfirmPasswordValidation(){
 // const [email, setEmail] = useState();
  const [password, setPassword] = useState();
  const [messagelog, setMessagelog] = useState("");
  const [errormesg, setErrormesg] = useState("");
  const {email} = useParams();

  const navigate = useNavigate();
  //const [device_name, setDevice] = useState();
  const getUA = () => {
    let device = "Unknown";
    const ua = {
        "Generic Linux": /Linux/i,
        "Android": /Android/i,
        "Samsung": /SM/i,
        "BlackBerry": /BlackBerry/i,
        "Bluebird": /EF500/i,
        "Chrome OS": /CrOS/i,
        "Datalogic": /DL-AXIS/i,
        "Honeywell": /CT50/i,
        "iPad": /iPad/i,
        "iPhone": /iPhone/i,
        "iPod": /iPod/i,
        "macOS": /Macintosh/i,
        "Windows": /IEMobile|Windows/i,
        "Zebra": /TC70|TC55/i,
    }
    Object.keys(ua).map(v => navigator.userAgent.match(ua[v]) && (device = v));
    return device;
}

//console.log(getUA());

  const device_name = getUA();
  async function simpleregister() {
   // console.log(email);
  //  console.log(passwordInput.confirmPassword);
   // console.log(passwordInput.password);
   // console.log(errormesg);

    if(email!=="" && errormesg==''  && passwordInput.confirmPassword===passwordInput.password  && password===passwordInput.password){
    let item = { email, password, device_name };
    let result = await fetch(register, {
      method: 'POST',
      headers: {
        "Content-Type": "application/json",
        "Accept": 'application/json'
      },
      body: JSON.stringify(item)
    });

    result = await result.json();
    console.log((result.message.code));

    if(result.message.code =='200'){

      window.dataLayer = window.dataLayer || [];

      window.dataLayer.push({
      event: 'sign_up',
      user_id: result.user.id,
      method: "email"
      });

      console.log('jererere');
      const defaultLocale = localStorage['locale'] ? localStorage['locale'] : 'en'; 
      localStorage.setItem("user-info", JSON.stringify(result));
      navigate('/UpdateName');
    } 
    else{
     // navigate('/registersimple');
     setMessagelog(result.message.message);
    }
    //history('/add');
  }else{
    setMessagelog('الرجاء تأكد انك ادخلت جميع الخانات قبل التسجيل ');
  }
  }


const [passwordError, setPasswordErr] = useState("");
const [confirmPasswordError, setConfirmPasswordError] = useState("");
const [passwordInput, setPasswordInput]= useState({
    password:'',
    confirmPassword:''
})
const handlePasswordChange =(evnt)=>{
    const passwordInputValue = evnt.target.value.trim();
    const passwordInputFieldName = evnt.target.name;
    const NewPasswordInput = {...passwordInput,[passwordInputFieldName]:passwordInputValue}
    setPasswordInput(NewPasswordInput);
   // setPassword(NewPasswordInput);
    
}
const handleValidation= (evnt)=>{
    const passwordInputValue = evnt.target.value.trim();
    const passwordInputFieldName = evnt.target.name;
        //for password 
if(passwordInputFieldName==='password'){
    const uppercaseRegExp   = /(?=.*?[A-Z])/;
    const lowercaseRegExp   = /(?=.*?[a-z])/;
    const digitsRegExp      = /(?=.*?[0-9])/;
    const specialCharRegExp = /(?=.*?[#?!@$%^&*-])/;
    const minLengthRegExp   = /.{8,}/;
    const passwordLength =      passwordInputValue.length;
    const uppercasePassword =   uppercaseRegExp.test(passwordInputValue);
    const lowercasePassword =   lowercaseRegExp.test(passwordInputValue);
    const digitsPassword =      digitsRegExp.test(passwordInputValue);
    const specialCharPassword = specialCharRegExp.test(passwordInputValue);
    const minLengthPassword =   minLengthRegExp.test(passwordInputValue);
    let errMsg ="";
  /*  if(passwordLength===0){
      errMsg="الرجاء ادخال كلمة المرور";
      setErrormesg(errMsg);
}else if(!uppercasePassword){
      errMsg="حرف كبير واحد على الأقل";
      setErrormesg(errMsg);
}else if(!lowercasePassword){
      errMsg="حرف صغير واحد على الأقل";
      setErrormesg(errMsg);
}else if(!digitsPassword){
      errMsg="رقم واحد على الأقل";
      setErrormesg(errMsg);
}else if(!specialCharPassword){
      errMsg="حرف خاص واحد على الأقل";
      setErrormesg(errMsg);
}else if(!minLengthPassword){
      errMsg="8 أحرف على الأقل";
      setErrormesg(errMsg);
}else{
  errMsg="";
  setErrormesg(errMsg);
}*/


if(passwordLength===0){
  errMsg="الرجاء ادخال كلمة المرور";
  setErrormesg(errMsg);
}else if(!digitsPassword){
  errMsg="رقم واحد على الأقل";
  setErrormesg(errMsg);
}else if(!minLengthPassword){
  errMsg="8 أحرف على الأقل";
  setErrormesg(errMsg);
}else{
errMsg="";
setErrormesg(errMsg);
}
    setPasswordErr(errMsg);
    }
    // for confirm password
    if(passwordInputFieldName=== "confirmPassword" || (passwordInputFieldName==="password" && passwordInput.confirmPassword.length>0) ){
            
        if(passwordInput.confirmPassword!==passwordInput.password)
        {
        setConfirmPasswordError("تأكيد كلمة المرور غير متطابق");
        }else{
        setConfirmPasswordError("");
        setPassword(passwordInput.password);
        }
        
    }
}
    return(
      <>
 <Header backhref="#/" />
     
      <div className="grid-x align-center">
        <div className="cell shrink">
          <div className="return-btn hide-for-large">
           
          </div>
          <div className="form-area-wrap padding-vertical-3">
            <div className="section-title margin-bottom-2">
              <h3>اشترك واستمتع بمحتوانا مجاناً</h3>
         
              <p>سجل للحصول على تجربة فريدة</p>
            </div>
            <div className="message alert text-center ">
            {messagelog}
            </div>
            <div className="form-area">
            <div class="input-field"> 
                                            <span class="ico-label"><i class="icomoon-icon icon-envelop2"></i></span>
                                            <input type="email" name="email" required="required" placeholder="البريد الالكتروني"   value={email}/>
                                            <div class="required">*</div>
                                        </div>
                
   
              <PasswordInputField 
              handlePasswordChange={handlePasswordChange} 
              handleValidation={handleValidation} 
              passwordValue={passwordInput.password} 
              passwordError={passwordError}/>
              <ConfirmPasswordInputField 
              handlePasswordChange={handlePasswordChange} 
              handleValidation={handleValidation} 
              confirmPasswordValue={passwordInput.confirmPassword} 
              confirmPasswordError={confirmPasswordError}/>
          
                <button onClick={simpleregister} className="button submit-btn" >  التالي </button>
            
            </div>
          </div>
        </div>
      </div>
</>

  

    
    )
}
export default PasswordAndConfirmPasswordValidation;